<script>

export default {
    beforeMount(){
        this.redirect();
    },
    methods: {
        redirect: function(e){
            let uri = window.location.href.split('?');
            let vars = uri[1].split('&');
            var code, message;

            for (var key in vars) { 
                var kv = vars[key];
                var kvArr = kv.split('=');
                var k = kvArr[0];
                var v = kvArr[1];
                if(k == 'code'){
                    code = v;
                } else if(k == 'message'){
                    message = v;
                } 
            }

            var msg;
            if(code == 'PAY_PROCESS_CANCELED'){
                msg = '사용자에 의해 결제가 취소되었습니다. \n 관리자에게 문의하시려면 우측 하단 네이버톡톡 또는 채널톡을 이용해주세요.';
            } else if(code == 'PAY_PROCESS_ABORTED'){
                msg = '결제 진행 중 승인에 실패하여 결제가 중단되었습니다. \n 관리자에게 문의하시려면 우측 하단 네이버톡톡 또는 채널톡을 이용해주세요.';
            } else if(code == 'REJECT_CARD_COMPANY'){
                msg = '카드사 승인이 거절되었습니다. \n [결제 가능한 신용카드 안내]를 확인해주세요. \n 관리자에게 문의하시려면 우측 하단 네이버톡톡 또는 채널톡을 이용해주세요.';
            } else {
                msg = '결제 진행 중 승인에 실패하여 결제가 중단되었습니다. \n 관리자에게 문의하시려면 우측 하단 네이버톡톡 또는 채널톡을 이용해주세요.';
            } 

            swal(msg, {
                buttons: false,
                timer: 5000
            });
            setTimeout(() => {
                this.$router.push('/main/pc4?tab=membership')
            }, 5000);
                        
        }
    

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pay/KakaoFail.vue